import { render, staticRenderFns } from "./RequirementValueForm.vue?vue&type=template&id=138c80c2&"
import script from "./RequirementValueForm.vue?vue&type=script&lang=js&"
export * from "./RequirementValueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports